export const reportError = error => {
  if (typeof Ext !== 'undefined' && Ext && Ext.Msg) {
    Ext.Msg.alert('Operation Status', error);
  }
};

export default reportError;
